__webpack_require__.p = "//rythm-static.s3.yandex.net/web-prod/";